import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import {Provider} from "react-redux";
import store from './store/store'; // 更新路径

const APP_ENV = process.env.REACT_APP_ENV || 'development';

if (APP_ENV === 'development') {
  console.warn('[开发环境]');
} else if (APP_ENV === 'test') {
  console.warn('[测试环境]');
} else if (APP_ENV === 'preview') {
  console.warn('[预发布环境]');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>  {/* 将 Redux store 提供给整个应用 */}
        <React.StrictMode>
            <App/>
        </React.StrictMode>
    </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
